import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Farmer } from "types";
import type { TableColumn } from "common/components/DataTable/DataTable";
import CrudList from "common/components/Crud/CrudList";
import type { CrudFilter } from "common/components/Crud/components/CrudFilters";

function Farmers() {
  const { t } = useTranslation();

  const columns: TableColumn<Farmer>[] = useMemo(
    () => [
      {
        field: "name",
        header: t("farmers.name"),
        sortable: true,
        renderType: "bold",
      },
      {
        field: "phoneNumber",
        header: t("farmers.phoneNumber"),
      },
    ],
    [t]
  );

  const filters: CrudFilter[] = useMemo(
    () => [
      {
        name: "name$containsi",
        label: t("farmers.name"),
        renderType: "input",
      },
    ],
    [t]
  );

  return (
    <CrudList
      collectionName="farmers"
      columns={columns}
      filters={filters}
      defaultSort="name:ASC"
      canEdit={false}
      canDelete={false}
      canSeeDetails={false}
      icon="UserGroupIcon"
      actionsHeader=""
    />
  );
}

export default Farmers;
